const getHoursAndMinutes = (createdAt) => {
    const hours = `0${createdAt.getHours()}`.slice(-2);
    const minutes = `0${createdAt.getMinutes()}`.slice(-2);

    return `${hours}:${minutes}`
}

export default getHoursAndMinutes